import type { components } from "../../shared/api/generated/trading-engine.js";
import type { ChartFillView } from "./chart-models.js";

type Trade = components["schemas"]["ExecutedTrade"];

export interface LiveExecution {
  readonly action: string;
  readonly accountId: string;
  readonly botId?: string;
  readonly fillId: string;
  readonly occurredAt: string;
  readonly orderId: string;
  readonly origin: string;
  readonly priceUsd: string;
  readonly quantity: string;
}

function executionAction(trade: Trade): string {
  if (trade.side === "buy") return trade.positionEffect === "open" ? "enter-long" : "exit-short";
  return trade.positionEffect === "open" ? "enter-short" : "exit-long";
}

export function liveExecutionRows(trades: readonly Trade[]): readonly LiveExecution[] {
  return [...new Map(trades.map((trade) => [trade.id, trade])).values()]
    .flatMap((trade) =>
      trade.fills.map((fill) => ({
        action: executionAction(trade),
        accountId: trade.brokerAccountId,
        ...(trade.botId === undefined ? {} : { botId: trade.botId }),
        fillId: fill.id,
        occurredAt: fill.occurredAt,
        orderId: trade.id,
        origin: trade.origin,
        priceUsd: fill.priceUsd,
        quantity: fill.quantity,
      })),
    )
    .sort((left, right) => right.occurredAt.localeCompare(left.occurredAt));
}

export function chartFillsFromExecutions(rows: readonly LiveExecution[]): readonly ChartFillView[] {
  return rows.map((row) => ({
    action: row.action,
    feeUsd: "Unavailable",
    id: row.fillId,
    occurredAt: row.occurredAt,
    priceUsd: row.priceUsd,
    quantity: row.quantity,
  }));
}
